import * as React from "react";
import { Authenticator, ConfirmSignUp, SignIn } from "aws-amplify-react";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";

import { useAuth } from "./context/auth-context";
import MyConfirmSignUp from "./components/signup-confirm";
import CustomSignIn from "./components/custom-signin";

const AuthenticatedApp = React.lazy(() => import("./authenticated-app"));
const queryClient = new QueryClient();

function App() {
  const { user } = useAuth();

  if (!user) {
    return (
      <div className="auth-screen">
        <div className="auth-screen__ambient auth-screen__ambient--one" />
        <div className="auth-screen__ambient auth-screen__ambient--two" />
        <div className="auth-screen__inner">
          <section className="auth-screen__intro">
            <p className="auth-screen__eyebrow">ADELA ENERGY</p>
            <h1>Houston Operations Console</h1>
            <p>Monitor, control, and coordinate real-time platform activity from a single secure workspace.</p>
            <section className="auth-screen__panel">
              {/*
                Hide Amplify's built-in SignIn/ConfirmSignUp and render our
                custom variants so we can control form content/order precisely.
              */}
              <Authenticator hide={[ConfirmSignUp, SignIn]} signUpConfig={{ hiddenDefaults: "phone_number" }}>
                <CustomSignIn override={"signIn"} />
                <MyConfirmSignUp override={"confirmSignUp"} />
              </Authenticator>
            </section>
          </section>
        </div>
      </div>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <React.Suspense fallback={<div>Loading...</div>}>
        <AuthenticatedApp />
      </React.Suspense>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
